export default {
	id: 'SIMPLE_PREMIUM_3M_45_57',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_3m_45_57_usd',
			ARS: 'simple_premium_3m_51900_ars',
			AUD: 'simple_premium_3m_69_99_aud',
			BRL: 'simple_premium_3m_259_brl',
			CAD: 'simple_premium_3m_59_99_cad',
			CLP: 'simple_premium_3m_42900_clp',
			COP: 'simple_premium_3m_188900_cop',
			DKK: 'simple_premium_3m_299_dkk',
			EUR: 'simple_premium_3m_45_57_eur',
			GBP: 'simple_premium_3m_45_57_gbp',
			MXN: 'simple_premium_3m_879_mxn',
			NOK: 'simple_premium_3m_459_nok',
			PLN: 'simple_premium_3m_169_pln',
			SEK: 'simple_premium_3m_439_sek',
			TRY: 'simple_premium_3m_1779_try',
		},
		primer: 'prd_NsYO7QDCgnwt',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 45.57,
			ARS: 51900,
			AUD: 69.99,
			BRL: 259,
			CAD: 59.99,
			CLP: 42900,
			COP: 188900,
			DKK: 299,
			EUR: 45.57,
			GBP: 45.57,
			MXN: 879,
			NOK: 459,
			PLN: 169,
			SEK: 439,
			TRY: 1779,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.3mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.3mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.3mo.bar_chart_right_label'),
	}),
}
